/*
 * @Descripttion: 
 * @Version: 1.0
 * @Author: pj
 * @Date: 2023-01-30 14:09:32
 * @LastEditors: pj
 * @LastEditTime: 2023-01-30 14:09:34
 */
import Vue from 'vue'
import VueAwesomeSwiper from 'vue-awesome-swiper'

Vue.use(VueAwesomeSwiper)